// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"style_mainContainer__30lPw","shadowStyle":"style_shadowStyle__Nn06D"};